import { useTranslation } from '@utils/i18n/i18n.consumers';

import './map-instruction-card.styl'

function MapInstructionCard({ path }) {
  const category = path.split('/')[2] === 'stories' ? 'story' : 'plan';
  
  const { t } = useTranslation(); 
  return (
    <div className="map-instruction-card">
      <span>
        {t('Please click on the map to select the location of your adaptation {{category}}.', { category: t(category) })}
      </span>
    </div>
  )
}

export default MapInstructionCard
